import React, { useEffect } from 'react'
import { RouteComponentProps, useParams } from 'react-router'

import useMyhouse from '@Hooks/myhouse/useMyhouse'
import MyhouseNoticeDetailPage from '@Components/templates/MyhouseNoticeDetailPage'
import useNotice from '@Hooks/myhouse/notice/useNotice'
import useBoard from '@Hooks/myhouse/board/useBoard'
import { getDeniedPath, LAND_DENIED_TYPE } from '@Root/contants/myhouseError'

interface params {
  noticeSequence: string
  complexNo: string
}

function NoticeDetailPage(props: RouteComponentProps<any>) {
  const params = useParams<params>()

  const complexNo = parseInt(params.complexNo)
  const noticeSequence = parseInt(params.noticeSequence)

  const { setComplexNo, isLoaded } = useMyhouse()
  const { setNoticeSequence } = useNotice()
  const { getNoticesReadableComplexNo } = useBoard()

  if (!complexNo || !noticeSequence) {
    props.history.replace(getDeniedPath(LAND_DENIED_TYPE.BBS_LOAD_FAIL))
  }

  useEffect(() => {
    setComplexNo(complexNo)
  }, [complexNo])

  useEffect(() => {
    setNoticeSequence(noticeSequence)
  }, [noticeSequence])

  useEffect(() => {
    // 읽기 권한이 없는 경우
    if (isLoaded && !getNoticesReadableComplexNo(complexNo)) {
      if (props.history.length > 1) {
        props.history.goBack()
      } else {
        props.history.push(getDeniedPath(LAND_DENIED_TYPE.BBS_NOT_AUTH_READABLE))
      }
    }
  }, [isLoaded])

  return <>{getNoticesReadableComplexNo(complexNo) && <MyhouseNoticeDetailPage />}</>
}

export default NoticeDetailPage
